/** Maps marketing/QR ?event= hints to Connect ticketing_event_id values. */
const EVENT_HINTS: Record<string, string> = {
  melbourne: "deb2026-melbourne",
  sydney: "deb2026-sydney",
  "deb2026-melbourne": "deb2026-melbourne",
  "deb2026-sydney": "deb2026-sydney",
};

/** Resolve ?event= query value to a ticketing_event_id, or null if unknown. */
export function resolveEventHint(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const key = raw.trim().toLowerCase();
  return EVENT_HINTS[key] ?? null;
}